var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.theme }, [
    _c(
      "div",
      {
        staticClass: "pages",
        class: [
          _vm.activeIndex > 0 && _vm.theme != "blue" && _vm.theme != "yellow"
            ? "pt"
            : "",
        ],
        on: { mouseover: _vm.onHoverEnter, mouseleave: _vm.onHoverLeave },
      },
      [
        _vm.activeIndex > 0
          ? _c("Header", { on: { showMenu: _vm.showMenu } })
          : _vm._e(),
        _c("transition", { attrs: { name: "fade" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isMenu,
                  expression: "isMenu",
                },
              ],
              staticClass: "menu",
            },
            [
              _c("Menu", {
                on: { toMenu: _vm.toMenu, hideMenu: _vm.hideMenu },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          [
            _c(
              "swiper",
              {
                ref: "insideSwiper",
                class: { "custom-class": true },
                attrs: { options: _vm.insideSwiperOptions },
                on: { slideChange: _vm.slideChange },
              },
              [
                _c("swiper-slide"),
                _vm._l(_vm.menuData, function (item, index) {
                  return _c(
                    "swiper-slide",
                    { key: item.key },
                    [
                      _c(item.key, {
                        tag: "component",
                        attrs: { index: index },
                      }),
                    ],
                    1
                  )
                }),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeIndex > 0,
                      expression: "activeIndex > 0",
                    },
                  ],
                  staticClass: "swiper-pagination",
                  attrs: { slot: "pagination" },
                  slot: "pagination",
                }),
              ],
              2
            ),
          ],
          1
        ),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeIndex > 0 && _vm.isShowNav,
              expression: "activeIndex > 0 && isShowNav",
            },
          ],
          staticClass: "swiper-button-prev",
          attrs: { slot: "button-prev" },
          slot: "button-prev",
        }),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeIndex > 0 && _vm.isShowNav && _vm.isShowNext,
              expression: "activeIndex > 0 && isShowNav && isShowNext",
            },
          ],
          staticClass: "swiper-button-next",
          attrs: { slot: "button-next" },
          slot: "button-next",
        }),
        _vm.activeIndex > 0 ? _c("Footer") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }